import Vue from 'vue'

export default {

  state: Vue.observable({
    users: [],
  }),
  
  setUsers(users) {
    this.state.users = users
  },

  updateUser(newuser) {
    this.state.users = this.state.users.map(user => {
      return user.id == newuser.id ? newuser : user
    })
  },
}
